"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pipelines = _interopRequireDefault(require("./pipelines"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var executePipeline = function executePipeline(types, event) {
  var initialEvent = _objectSpread({}, event);

  var pipeline = [];
  types.forEach(function (type) {
    var typePipeline = _pipelines["default"][type] || [];
    typePipeline.forEach(function (step) {
      return pipeline.push(step);
    });
  });
  var processedEvent = pipeline.reduce(function (prevEvent, pipelineProcess) {
    return pipelineProcess(prevEvent);
  }, initialEvent);
  return processedEvent;
};

var _default = executePipeline;
exports["default"] = _default;